import { cls } from '@/utils';

const TableRenderLink = ({
	label,
	onClick,
	className,
}: {
	label?: string;
	onClick?: (e: React.MouseEvent<HTMLSpanElement>) => void;
	className?: string;
}) => {
	return label ? (
		<span
			className={cls(
				'text-blue2 underline cursor-pointer hover:text-blue3',
				className
			)}
			onClick={onClick}
		>
			{label}
		</span>
	) : (
		'-'
	);
};

export default TableRenderLink;
